import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MutexService } from "common/concurrency/mutex.service";
import { MainService } from "core/main.service";
import { ViewService } from "core/view.service";
import { ViewableNavigationConfigurationProvider } from "navigation/list/navigation-viewable-navigation.logic";
import { NavigationService } from "navigation/list/navigation.service";
import { NavigationSpec, ViewSpec } from "process/view/type.interface";
import { combineLatest, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DialogService } from "common/dialog/dialog.service";
import { TranslateService } from "@ngx-translate/core";
import { ViewableNavigationStore } from "navigation/list/viewable-navigation-store.interface";

@Component({
	templateUrl: "./viewable-navigation.component.html",
})
export class ViewableNavigationComponent implements OnDestroy {
	destroy$: Subject<boolean> = new Subject<boolean>();

	constructor(
		private route: ActivatedRoute,
		navigationService: NavigationService,
		mutexService: MutexService,
		private mainService: MainService,
		navigationStore: ViewableNavigationStore,
		private viewService: ViewService,
		dialogService: DialogService,
		translateService: TranslateService,
	) {
		const navigationProvider = new ViewableNavigationConfigurationProvider(
			navigationService,
			mainService,
			mutexService,
			dialogService,
			translateService,
			navigationStore,
		);

		combineLatest([this.viewService.awaitSelfElementObservable(), this.route.paramMap])
			.pipe(takeUntil(this.destroy$))
			.subscribe(([view, params]) => {
				let navigationSpec: NavigationSpec;
				if (this.mainService.secondaryMode === "compare") {
					navigationSpec = {
						labelType: "change-marker",
						showAddButton: false,
					};
				} else if (this.mainService.secondaryMode === "compliance") {
					navigationSpec = {
						labelType: "two-line-split-rating",
						showAddButton: false,
					};
				} else {
					navigationSpec = (view.viewType as ViewSpec).navigation;
				}

				navigationProvider.updateNavigationFromParams(
					view as unknown as stages.process.ViewableElement,
					params,
					route,
					navigationSpec.showAddButton,
					navigationSpec.labelType,
				);
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}
}
